import { $apiV2, $apiWithoutClient } from 'modules/global';

export const getTopicTests =
  ({
    search,
    page,
    languageId,
    name,
    size = 30
  }: {
    search?: string;
    page?: string;
    name?: string;
    languageId?: number;
    size?: number;
  }) =>
  async () => {
    const { data } = await $apiV2.get('/themed-test/view', {
      params: { page, size, language_id: languageId, name, search }
    });

    return data;
  };

export const getSitemapTopicTests = async () => {
  const { data } = await $apiWithoutClient.get('/sitemap/themed');

  return data;
};
